/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  InstallCodesBulkUploadRequest,
  InstallCodesUploadResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Bulk upload install codes.
 */
export const uploadInstallCodes = (
  installCodesBulkUploadRequest: InstallCodesBulkUploadRequest,
  options?: SecondParameter<
    typeof backofficeRequest<InstallCodesUploadResponse>
  >,
) => {
  return backofficeRequest<InstallCodesUploadResponse>(
    {
      url: `/install-codes/bulk-upload`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: installCodesBulkUploadRequest,
    },
    options,
  )
}
export type UploadInstallCodesResult = NonNullable<
  Awaited<ReturnType<typeof uploadInstallCodes>>
>
